module.exports = __webpack_public_path__ + "media/images/instagram-brands-884e172d47cd7936648ccd9b89f1e38c.svg";